var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#7247FF","fillRule":"evenodd","d":"M7.162 12.683c-.797-1.25-.618-2.888.431-3.937L9.21 7.13c.617-.618 1.62-.618 2.237 0l2.241 2.242c.618.617.618 1.619 0 2.237l-1.677 1.678c.744 1.49 1.675 2.793 2.792 3.91 1.117 1.117 2.422 2.05 3.915 2.797l1.678-1.678c.617-.618 1.619-.618 2.237 0l2.237 2.237c.618.618.618 1.62 0 2.237l-1.616 1.617c-1.05 1.049-2.686 1.228-3.937.43v.001c-2.475-1.576-4.725-3.377-6.75-5.403-2.027-2.026-3.828-4.276-5.405-6.752z"}));
}

Phone.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Phone;

Phone.default = Phone;
